import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { ChipsItem, Label } from '@atlas/ui';

const CasinoInlineFilterItem = ({ changeFilter, field, name }) => {
  const onClick = useCallback(() => {
    changeFilter(field, name);
  }, [name, changeFilter, field]);

  const keyName = name.toLowerCase();

  const label = <Label message={keyName} />;

  return <ChipsItem active icon="close" label={label} onClick={onClick} />;
};

CasinoInlineFilterItem.propTypes = {
  changeFilter: PropTypes.func,
  field: PropTypes.string,
  name: PropTypes.string,
};

export default CasinoInlineFilterItem;
